// extracted by mini-css-extract-plugin
module.exports = {"container":"RampLoadingStatusModal_container__2i0-V","indexName":"RampLoadingStatusModal_indexName__1Nq4m","colBackground":"RampLoadingStatusModal_colBackground__2QpO-"};